import { useState } from "react";
import { useNavigate } from "react-router";
import { login } from "@/lib/api/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/ui/password-input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AuthLayout } from "@/components/auth/auth-layout";
import { toast } from "@/components/ui/toaster";
import { asset } from "@/lib/asset";

export function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setPending(true);
    setError(null);
    const fd = new FormData(e.currentTarget);
    const result = await login(fd.get("email") as string, fd.get("password") as string);
    if (result.error) {
      setError(result.error);
      setPending(false);
      toast.error("Inloggen mislukt", "Controleer je e-mailadres en wachtwoord en probeer het opnieuw.");
    } else {
      navigate("/", { replace: true });
    }
  }

  return (
    <AuthLayout
      footer={
        <a href="/managing/" className="font-medium text-muted-foreground hover:text-primary">
          Naar het influencer-dashboard
        </a>
      }
    >
      <div className="mb-7 flex flex-col items-center text-center sm:mb-0 sm:pb-6 sm:pt-7">
        <img
          src={asset("favicon.png")}
          alt="Prado"
          className="h-11 w-11 select-none rounded-xl border border-border/60 bg-card object-contain p-1.5 shadow-sm"
          draggable={false}
        />
        <h1 className="mt-4 text-[26px] font-bold leading-tight tracking-tight text-foreground sm:text-[28px]">
          Welkom terug
        </h1>
        <p className="mt-1.5 text-sm text-muted-foreground">
          Log in op je marketing-dashboard.
        </p>
      </div>

      {error && (
        <Alert variant="error">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <form onSubmit={handleSubmit} className="mt-6 space-y-4 sm:mt-0">
        <div className="space-y-2">
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" name="email" type="email" placeholder="jij@prado.com" autoComplete="email" required className="h-12 lg:h-10" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Wachtwoord</Label>
          <PasswordInput id="password" name="password" placeholder="••••••••" autoComplete="current-password" required className="h-12 lg:h-10" />
        </div>
        <Button type="submit" className="h-12 w-full lg:h-10" disabled={pending}>
          {pending ? "Bezig met inloggen…" : "Inloggen"}
        </Button>
      </form>

    </AuthLayout>
  );
}
